import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import AdGallery from "./AdGallery";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_agentic-curation/artifacts/zri9wsj7_ingenium-logo.png";

const PublicGallery = () => {
  const { slug } = useParams();
  const [adUrls, setAdUrls] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/gallery/link/${slug}`)
      .then(res => setAdUrls(res.data.ad_urls || []))
      .catch(() => setError("This gallery link is invalid or has expired."))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#141414] flex items-center justify-center">
        <div className="text-[#ebebeb]/40 font-mono text-sm">Loading gallery...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#141414] flex items-center justify-center">
        <div className="text-center">
          <p className="text-[#ebebeb]/50 font-mono text-sm mb-4">{error}</p>
          <a href="/" className="text-[#ff3737] font-mono text-sm hover:underline">Go to Homepage</a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#141414]">
      <header className="border-b border-white/5 px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <img src={LOGO_URL} alt="Ingenium Digital" className="h-7" />
          <a href="/" className="text-[#ebebeb]/40 hover:text-white text-xs font-mono transition-colors" data-testid="public-gallery-home-link">
            ingenium-digital.com
          </a>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-8">
        <AdGallery mode="public" publicAdUrls={adUrls} />
      </main>
    </div>
  );
};

export default PublicGallery;
